<template>
    <div class="form-control-component-volume" :style="style" @click.prevent="focus">
        <input
            :ref="`volume_${_uid}`"
            v-bind="$attrs"
            :value="value"
            type="number"
            class="form-control"
            :disabled="disabled"
            :placeholder="placeholder"
            @input="$emit('input', $event.target.value)">
    </div>
</template>

<script>
import { getUnitText } from '@/components/SelectUnit'

export default {
    inheritAttrs: false,

    props: {
        value: {
            type: String | Number,
            default: ''
        },

        disabled: {
            type: Boolean,
            default: false
        },

        unit: {
            type: Number,
            default: null
        },

        placeholder: {
            type: String,
            default: 'Кол-во'
        }
    },

    computed: {
        style() {
            return { '--unit': this.unit && "'" + getUnitText(this.unit) + "'" }
        },

        listeners() {
            const { input, ...listeners } = this.$listeners
            return listeners
        }
    },

    methods: {
        focus() {
            this.$refs[`volume_${this._uid}`].focus()
        }
    }
}
</script>

<style lang="scss">
@import "../scss/_variables";

.form-control-component-volume {
  --unit: "";

  width: 100px;
  position: relative;
  cursor: text;
  line-height: 3;

  &::before {
    position: absolute;
    top: calc(50% - 21px);
    right: 0.75rem;

    color: $input-placeholder-color;
    content: var(--unit);
  }

  & > input.form-control {
    padding-right: 2.5rem;
  }
}
</style>
